import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=0204bb85"
import script from "./studentList.vue?vue&type=script&lang=js"
export * from "./studentList.vue?vue&type=script&lang=js"
import style0 from "./studentList.vue?vue&type=style&index=0&id=0204bb85&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports